import { Injectable } from '@angular/core';

/**
 * Responsible to decide if some resource(represented by url) is require authentication.
 * By default this ignores any static resources and authentication specific endpoints
 */
@Injectable({
    providedIn: 'root'
})
export class AuthenticationResourceFilter {

    private staticResourcesRegexp = new RegExp('(js|css|html|png|jpeg|jpg|svg)');

    /**
     * check if authentication is required for url
     * @param url - url
     */
    public isAuthenticationRequired(url: string): boolean {

        return !(this.staticResourcesRegexp.test(url)
            || url.indexOf('/i18n') !== -1
            || url.indexOf('/json-data') !== -1
            || url.indexOf('/api/public') !== -1);
    }
}
